import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card } from '@material-ui/core';
import NoItems from './NoItems';
import { useCardStyles } from '../../App';
import { ItemCardHeader } from './ItemCardHeader';
import { UserCardHeader } from './UserCardHeader';
import SearchBar from '../Searchbars/SearchBar';

export type ItemListProps = {
	name: string;
	items: any[];
	isUser?: boolean;
	append?: string;
};

const ItemList = (props: ItemListProps) => {
	const cardStyles = useCardStyles();
	const history = useHistory();

	const onSelectItem = (id: string | undefined) => {
		if (id) {
			history.push(`/${props.append?props.append:''}${props.name}/details/${id}`);
		}
	};

	const handleSearch = () => {

	}

	return (
		<>
			<Box>
				{!props.items || !props.items.length ? (
					<>
						<NoItems name={props.name} />
					</>
				) : props.items.length === 0 ? (
					<NoItems name={props.name} />
				) : (
					<>
						<SearchBar name={props.name} items={props.items} onSearch={handleSearch} />
						{props.items.map((item: any) => {
							return (
								<Card
									className={cardStyles.card}
									key={'item-' + item.id}
									onClick={() => onSelectItem(item.id)}
								>
									<div className={cardStyles.clickable}>
										{props.isUser ? (
											<UserCardHeader user={item} />
										) : (
											<ItemCardHeader item={item} />
										)}
									</div>
								</Card>
							);
						})}
					</>
				)}
			</Box>
		</>
	);
};

export default ItemList;
